import styled from 'styled-components'
export const RoleCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #ffffff;
`

export const RoleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const RoleTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #2a4365;
`

export const CompanyName = styled.div`
  font-size: 14px;
  color: #4a5568;
`

export const RoleDetails = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  align-items: center;
`

export const IconGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  white-space: nowrap;
`

export const ContainarCardContant = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ShapeTag = styled.div`
  background-color: ${({ orderNo }) =>
    getOrderBasedColor(orderNo)?.borderColor};
  color: #000000;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 400;
  width: fit-content;
`

export const BorderBoxTag = styled.div`
  padding: ${props => props.padding || '8px 8px'};
  ${({ orderNo }) => {
    const { color, borderColor, background } = getOrderBasedColor(orderNo)
    return `
      border: 2px solid  ${borderColor} !important;
      background-color: ${background};
    `
  }}
  border-radius: 8px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const IconContainar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`
export const RoundCardIconContainar = styled.div`
  display: flex;
  justify-content: end;
`

export const RoundCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ roundsLength }) => (roundsLength === 4 ? '14px' : '20px')};
  margin-top: 10px;
  margin-bottom: 15px;
  justify-content: ${({ roundsLength }) =>
    roundsLength === 4 ? 'space-between' : 'flex-start'};
`

export const IconContainer = styled.div`
  font-size: 30px;
`

export const RoundCard = styled.div`
  width: 118px;
  padding: 10px;
  border-radius: 12px;
  text-align: center;
  font-size: 12px;
  // font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  background-color: ${({ status }) => {
    switch (status) {
      case 'SHORTLIST':
        return '#DFF0EA'
      case 'ABSENT':
        return '#FFF5DD'
      case 'YET_TO_UPDATE':
        return '#EDEDED'
      default:
        return '#FFFFFF'
    }
  }};
  color: ${({ status }) => {
    switch (status) {
      case 'SHORTLIST':
        return '#5DB594'
      case 'ABSENT':
        return '#FFC849'
      case 'YET_TO_UPDATE':
        return '#888888'
      default:
        return '#FFFFFF'
    }
  }};
`
export const TextAlign = styled.div`
  margin-bottom: 20px;
`
export const JobText = styled.span`
  color: #242e39;
  white-space: nowrap;
`

export const getOrderBasedColor = orderNo => {
  if (orderNo === null) {
    return {
      // Default styling
      color: '#000000',
      borderColor: '#DBDBDB',
      background: '#EDEDED1A',
    }
  }
  switch (orderNo) {
    case 1:
      return {
        color: '#000000',
        borderColor: '#CCCCCC',
        background: '#CCCCCC33', // 20% opacity of #CCCCCC
      }
    case 2:
      return {
        color: '#000000',
        borderColor: '#97CADB',
        background: '#97CADB33', // 20% opacity of #97CADB
      }
    case 3:
      return {
        color: '#000000',
        borderColor: '#B5A3F7',
        background: '#B5A3F733', // 20% opacity of #B5A3F7
      }
    case 4:
      return {
        color: '#000000',
        borderColor: '#E1A7BA',
        background: '#E1A7BA33', // 20% opacity of #E1A7BA
      }
    case 5:
      return {
        color: '#000000',
        borderColor: '#F29F05',
        background: '#F29F0533', // 20% opacity of #F29F05
      }
    case 6:
      return {
        color: '#000000',
        borderColor: '#F25C05',
        background: '#F25C0533', // 20% opacity of #F25C05
      }
    case 7:
      return {
        color: '#000000',
        borderColor: '#72B06F',
        background: '#72B06F33', // 20% opacity of #72B06F
      }
    case 8:
      return {
        color: '#000000',
        borderColor: '#4C1D91',
        background: '#4C1D9133', // 20% opacity of #4C1D91
      }
    case 9:
      return {
        color: '#000000',
        borderColor: '#02457A',
        background: '#02457A33', // 20% opacity of #02457A
      }
    case 10:
      return {
        color: '#000000',
        borderColor: '#595F33',
        background: '#595F3333', // 20% opacity of #595F33
      }
    case 11:
      return {
        borderColor: '#000000',
      }
    default:
      return {
        // Default style for unmatched cases
        color: '#000000',
        borderColor: '#DBDBDB',
        background: '#DBDBDB33', // 20% opacity of #DBDBDB
      }
  }
}
